import Modal from "react-modal";

const AddCourseModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      contentLabel="Product Modal"
      // onRequestClose={() => onCloseModal()}
    >
      <div className="px-6 py-4 bg-white">
        <h3 className="font-medium text-lg ">Add Course</h3>

        <div className="border border-dismiss-focus rounded-xl px-6 py-6 mt-6 w-full">
          <h2 className="text-base font-semibold">Course Details</h2>

          <hr className="my-4" />

          <div></div>
        </div>
      </div>
    </Modal>
  );
};

const customStyles: any = {
  overlay: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    position: "fixed",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
  content: {
    padding: 0,
    height: "auto",
    border: "none",
    overflow: "auto",
    maxWidth: "824px",
    background: "none",
    left: "calc(50vw - 492px)",
    WebkitOverflowScrolling: "touch",
  },
};

export default AddCourseModal;
